import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar';
const {onModeEnter, onModeLeave, getMode} = require('./media.js');

export default class StickyRegSideBar {

    constructor (options) {
        this.options = $.extend({
            node: '.user-api--search',
            selectorPrefix: '',
            threshold: 75
        }, options);

        //     let $sticky = this.options.node,
        //     if (scroll > this.options.threshold){

        this._initStickySidebar();
    }

    _enableStickySidebar() {
        this.sidebar = new StickySidebar(this.options.selectorPrefix + this.options.node, {
            topSpacing: this.options.threshold,
            bottomSpacing: this.options.threshold,
            containerSelector: this.options.selectorPrefix + '.user-api--wrapper',
            innerWrapperSelector: this.options.selectorPrefix + '.stixty-content',
            resizeSensor: true,
            stickyClass: 'is-affixed',
        });
        this._observeTabVisibility();
    }

    _observeTabVisibility() {
        const sidebarEl = document.querySelector(this.options.selectorPrefix + this.options.node);
        if (!sidebarEl) return;
        const panel = sidebarEl.closest('.tab--item');
        if (!panel) return;

        this._tabObserver = new MutationObserver(() => {
            if (panel.classList.contains('in') && !panel.hasAttribute('hidden')) {
                requestAnimationFrame(() => this.sidebar && this.sidebar.updateSticky());
            }
        });
        this._tabObserver.observe(panel, { attributes: true, attributeFilter: ['class', 'hidden'] });
    }

    _disableStickySidebar() {
        this.sidebar.destroy();
        if (this._tabObserver) { this._tabObserver.disconnect(); this._tabObserver = null; }
    }

    _initStickySidebar(){
        if( getMode() == 'desktop' ){
            this._enableStickySidebar();
        }

        onModeEnter('desktop', () => {
            this._enableStickySidebar();
        });

        onModeLeave('desktop', () => {
            this._disableStickySidebar();
        });
    }

    _reinitStickySidebar(){
        if( getMode() == 'desktop' ){
            this.sidebar.updateSticky();
        }
    }

};